import React, {
} from 'react';
import {
  useNavigate,
} from 'react-router-dom';
import i18n from 'i18next';

import {
  Button,
  Select,
  Tooltip,
  Checkbox,
  EntityList,
  Breadcrumbs,
  ContentWrapper,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

import {
  OpenedTooltip,
} from 'web-types';

import SearchOption from './SearchOption';
import * as S from './styled';

type Item = {
  id: number;
  name: string;
};

type Option = {
  value: string;
  label: string;
};

interface Props {
  basePath: string;
  items: Item[];
  breadcrumbs: Item[];
  searchOptions: Array<Option>;
  folderRoots: any[];
  folder: any;
  resourceType: string;
  openedTooltips: OpenedTooltip[];
  onSelect: { (): void };
  onSelectAll: { (): void };
  onChangeName: { (item: any, newName: string): void };
  onRequestAddEntity: { (): void };
  onRequestAddFolder: { (): void };
  onRequestRenameFolder: { (): void };
  onRequestDeleteFolder: { (): void };
  onRequestMoveEntity: { (): void };
  onRequestCopyEntity: { (): void };
  onRequestDuplicateEntity: { (id: number): void };
  onRequestCreateEntity: { (name: string): void };
  onRequestDeleteEntity: { (): void };
  onRemoveEntityTooltip: { (tooltip: OpenedTooltip): void };
}

const EntityFolder = ({
  items,
  folder,
  basePath,
  folderRoots,
  breadcrumbs,
  searchOptions,
  resourceType,
  openedTooltips,
  onSelect,
  onSelectAll,
  onChangeName,
  onRequestAddEntity,
  onRequestAddFolder,
  onRequestRenameFolder,
  onRequestDeleteFolder,
  onRequestMoveEntity,
  onRequestCopyEntity,
  onRequestDuplicateEntity,
  onRequestCreateEntity,
  onRequestDeleteEntity,
  onRemoveEntityTooltip,
}: Props) => {
  const navigate = useNavigate();
  const hasTooltip = openedTooltips.some(el => el.key === `add_${resourceType}`);
  return (
    <ContentWrapper
      header={(
        <Flex
          fillSpace
          column
          justify="center"
        >
          <Flex
            width="100%"
            height="50px"
            align="center"
            justify="space-between"
          >
            <Flex align="center" spacing={10}>
              {(items.some(item => !item.is_root)) && (
                <Checkbox
                  checked={items
                    .filter(item => !item.is_root)
                    .every(item => item.selected)}
                  onChange={onSelectAll}
                />
              )}
              <Breadcrumbs
                items={breadcrumbs}
                basePath={basePath}
                backPath={(folder.is_warmap || folder.is_cooldown)
                  ? '/workout_templates_folder'
                  : `${basePath}_folder`}
                parentId={(folder.is_warmap || folder.is_cooldown)
                  ? folderRoots.workoutId
                  : folder.parent_id}
                hideBackChevron={folder.is_root && !folder.is_cooldown && !folder.is_warmap}
              />
              {hasTooltip ? (
                <Tooltip
                  body={i18n.t(`tooltip.add.${resourceType}`)}
                  toggleMode
                  initialState
                >
                  <Button
                    appearance="success"
                    icon="fa fa-plus"
                    onClick={onRequestAddEntity}
                  >
                    {i18n.t(`add.${resourceType}`)}
                  </Button>
                </Tooltip>
              ) : (
                <Button
                  appearance="success"
                  icon="fa fa-plus"
                  onClick={onRequestAddEntity}
                >
                  {i18n.t(`add.${resourceType}`)}
                </Button>
              )}
            </Flex>
            <Flex spacing={10}>
              {breadcrumbs.length > 1 && (
                <Button
                  ghost
                  appearance="primary"
                  icon="fas fa-pencil-alt"
                  onClick={onRequestRenameFolder}
                >
                  Edit folder name
                </Button>
              )}
              <Tooltip
                body={i18n.t('tooltip.create.folder')}
                positions={['left']}
              >
                <Button
                  ghost
                  appearance="primary"
                  icon="fa fa-plus"
                  onClick={onRequestAddFolder}
                >
                  Add folder
                </Button>
              </Tooltip>
              {items.some(item => item.selected) && (
                <>
                  <Button
                    ghost
                    appearance="primary"
                    onClick={onRequestCopyEntity}
                  >
                    Copy
                  </Button>
                  <Button
                    ghost
                    appearance="primary"
                    onClick={onRequestMoveEntity}
                  >
                    Move to
                  </Button>
                  <Button
                    ghost
                    appearance="danger"
                    onClick={onRequestDeleteEntity}
                  >
                    Delete
                  </Button>
                </>
              )}
            </Flex>
          </Flex>
          <S.Search>
            <Select
              value=""
              creatable
              isClearable
              options={searchOptions}
              placeholder={i18n.t(`search.placeholder.${resourceType}`)}
              styles={{
                menuList: provided => ({
                  ...provided,
                  maxHeight: '316px',
                }),
                control: provided => ({
                  ...provided,
                  boxShadow: 'none',
                  borderColor: 'hsl(0,0%,80%)',
                }),
              }}
              components={{ Option: SearchOption }}
              onChange={(item) => {
                if (item && item.value) {
                  navigate(`${basePath}/${item.value}`);
                }
              }}
              onDuplicate={onRequestDuplicateEntity}
              onCreateOption={onRequestCreateEntity}
            />
          </S.Search>
        </Flex>
      )}
    >
      <Flex column fillSpace>
        <EntityList
          items={items}
          basePath={basePath}
          resourceType={resourceType}
          openedTooltips={openedTooltips}
          onSelect={onSelect}
          onChangeName={onChangeName}
          onRequestAdd={onRequestAddEntity}
          onRequestDelete={onRequestDeleteFolder}
          onRemoveEntityTooltip={onRemoveEntityTooltip}
        />
      </Flex>
    </ContentWrapper>
  );
};

export default EntityFolder;
